import styles from './ConsultationBanner.module.scss'

function ConsultationBanner() {
	const handleConsultationClick = () => {
		const formSection = document.getElementById('form-section')
		if (formSection) {
			const rect = formSection.getBoundingClientRect()
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop
			const offsetTop = rect.top + scrollTop
			const centerOffset = window.innerHeight / 2 - rect.height / 2

			// Плавный скролл к форме
			window.scrollTo({
				top: offsetTop - centerOffset,
				behavior: 'smooth',
			})

			// Устанавливаем значение "Консультация" в select направления
			const select = formSection.querySelector('select[name="direction"]')
			if (select) select.value = 'Консультация'
		}
	}

	return (
		<section className={styles.consultationBanner}>
			<div className={styles.consultationBanner__content}>
				<img
					src='/img/stock/consult-image.png'
					alt='Консультация'
					className={styles.consultationBanner__img}
				/>
				<div className={styles.consultationBanner__textBlock}>
					<h2 className={styles.consultationBanner__title}>
						<span>“АВАДА КЕДАВРА!”</span> — НЕ ПОМОЖЕТ ВЫБРАТЬ КУРС НАУГАД!
					</h2>
					<p className={styles.consultationBanner__subtitle}>
						Запишитесь на консультацию — и получите волшебную помощь!
					</p>
					<button
						className={styles.consultationBanner__button}
						onClick={handleConsultationClick}
					>
						Получить консультацию
						<img src='./img/all/arrow.svg' alt='' />
					</button>
				</div>
			</div>
		</section>
	)
}

export default ConsultationBanner
